<template>
    <div>
        <div class="uk-modal-header">
            <h2>Reset My Password</h2>
        </div>
        <div class="modal-body">
            <form class="uk-form" role="form" @submit.prevent.stop="send">
                <form-input
                    id="email"
                    v-model="email"
                    name="email"
                    type="email"
                    :error="has_error('email')"
                    :required="true"
                    placeholder="Email"
                    size="large"
                    width="1-1"
                    @input="update_email"
                />

                <div class="uk-text-center uk-margin-top">
                    <feedback-button
                        type="submit"
                        :status="feedback_status"
                        :waiting="loading"
                        :single-use="false"
                        color="primary"
                        @click.prevent="send"
                    >
                        <template v-slot:message>
                            <div
                                :class="{ 'uk-text-danger': (feedback_status === false) }"
                            >
                                {{ feedback_message }}
                            </div>
                        </template>
                        Send Me A Password Reset Link
                    </feedback-button>
                </div>
            </form>
        </div>
        <div class="uk-modal-footer uk-text-center">
            <base-button
                flavor="link"
                size="small"
                class="uk-margin-top"
                @click.native.prevent="goto('login')"
            >
                Got it! Just found my password!
            </base-button>
        </div>
    </div>
</template>

<script>
import is_panel from "./IsPanel"

import FormInput from "../../ui/FormInput"
import FeedbackButton from "../../ui/FeedbackButton"
import BaseButton from "../../ui/BaseButton"

export default {
    mixins: [is_panel],
    components: {
        FormInput,
        FeedbackButton,
        BaseButton
    },
    methods: {
        send () {
            setTimeout(() => {
                this.loading = true
                this.clear_all_errors()
                this.$store.dispatch("SEND_PASSWORD_RESET",
                    {
                        email: this.email
                    }
                ).then(data => {
                    this.feedback_status = true
                    this.feedback_message = data.message
                }).catch(this.receive_error).then(() => {
                    this.loading = false
                })
            }, this.autofill_timeout)
        }
    },
    data () {
        return {
            handles_feedback: true
        }
    }
}
</script>
